import { makeStyles } from "@mui/styles";
import { COLORS } from "../../../constant/colors";

export default makeStyles(() => ({
  whyChooseSec: {
    padding: "80px 0",
    background: COLORS.white,
    marginBottom: 0,
    "@media (max-width: 600px)": {
      padding: "30px 0 50px",
    },
  },
  sectionHeader: {
    textAlign: "center",
    marginBottom: 60,
    "@media (max-width: 600px)": {
      marginBottom: 20,
    },
  },
  heading: {
    fontSize: "2.5rem",
    fontWeight: 700,
    color: COLORS.textPrimary,
    marginBottom: 16,
    fontFamily: "'Poppins', sans-serif",
    position: "relative",
    "&::after": {
      content: '""',
      position: "absolute",
      bottom: -8,
      left: "50%",
      transform: "translateX(-50%)",
      width: 60,
      height: 4,
      background: `linear-gradient(90deg, ${COLORS.primary} 0%, ${COLORS.secondary} 100%)`,
      borderRadius: 2,
    },
    "@media (max-width: 600px)": {
      fontSize: "1.8rem",
      marginBottom: 12,
    },
  },
  subheading: {
    fontSize: "1.1rem",
    color: COLORS.textSecondary,
    maxWidth: 600,
    margin: "0 auto !important",
    lineHeight: 1.6,
    fontFamily: "'Poppins', sans-serif",
    "@media (max-width: 600px)": {
      fontSize: "0.9rem",
    },
  },
  featuresGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
    gap: 40,
    maxWidth: 1200,
    margin: "0 auto",
    "@media (max-width: 768px)": {
      gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
      gap: 30,
    },
    "@media (max-width: 480px)": {
      gridTemplateColumns: "1fr",
      gap: 24,
    },
  },
  featureCard: {
    textAlign: "center",
    padding: "40px 24px",
    borderRadius: 20,
    background: `linear-gradient(135deg, ${COLORS.backgroundLight} 0%, ${COLORS.white} 100%)`,
    border: `1px solid ${COLORS.borderLight}`,
    transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
    "&:hover": {
      transform: "translateY(-8px)",
      boxShadow: "0 16px 32px rgba(0, 0, 0, 0.1)",
      borderColor: COLORS.saffron,
    },
    "&:hover $featureIcon": {
      transform: "scale(1.1)",
    },
    "@media (max-width: 600px)": {
      padding: "20px 15px",
    },
  },
  featureIcon: {
    width: 80,
    height: 80,
    margin: "0 auto 24px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "50%",
    background: `linear-gradient(135deg, ${COLORS.secondary} 0%, ${COLORS.saffronLight} 100%)`,
    color: COLORS.white,
    transition: "all 0.3s ease",
    "& svg": {
      width: 32,
      height: 32,
    },
    "@media (max-width: 600px)": {
      width: 70,
      height: 70,
      "& svg": {
        width: 30,
        height: 30,
      },
      marginBottom: "13px",
    }
  },
  featureTitle: {
    fontSize: "1.3rem",
    fontWeight: 600,
    color: COLORS.textPrimary,
    marginBottom: 16,
    fontFamily: "'Poppins', sans-serif",
    "@media (max-width: 600px)": {
      marginBottom: "8px !important",
    },
  },
  featureDescription: {
    fontSize: "0.95rem",
    color: COLORS.textSecondary,
    lineHeight: 1.6,
    fontFamily: "'Poppins', sans-serif",
  },
}));
